// [檔案： src/js/reports.js]

import { dom } from './dom.js';
import * as state from './state.js';
import { formatCurrency, formatMonthDisplay, escapeHTML } from './utils.js';
import { t } from './i18n.js';
import { storageService } from './storage.js';

// 分類圖示 (與 transactions.js 保持一致)
const categoryIcons = {
    'cat_food': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/><path d="M7 2v20"/><path d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"/></svg>',
    'cat_transport': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 6v6"/><path d="M15 6v6"/><path d="M2 12h19.6"/><path d="M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3"/><circle cx="7" cy="18" r="2"/><path d="M9 18h5"/><circle cx="16" cy="18" r="2"/></svg>',
    'cat_shopping': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><path d="M2.048 18.566A2 2 0 0 0 4 21h16a2 2 0 0 0 1.952-2.434l-2-9A2 2 0 0 0 18 8H6a2 2 0 0 0-1.952 1.566z"/><path d="M8 11V6a4 4 0 0 1 8 0v5"/></svg>',
    'cat_entertainment': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="2"/><path d="M12 2v4"/><path d="m6.8 15-3.5 2"/><path d="m20.7 7-3.5 2"/><path d="M6.8 9 3.3 7"/><path d="m20.7 17-3.5-2"/><path d="m9 22 3-8 3 8"/><path d="M8 22h8"/><path d="M18 18.7a9 9 0 1 0-12 0"/></svg>',
    'cat_housing': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>',
    'cat_medical': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"/><path d="M3.22 13H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27"/></svg>',
    'cat_education': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>',
    'cat_general': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><rect width="7" height="7" x="3" y="3" rx="1" /><rect width="7" height="7" x="14" y="3" rx="1" /><rect width="7" height="7" x="14" y="14" rx="1" /><rect width="7" height="7" x="3" y="14" rx="1" /></svg>',
    'cat_salary': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><rect width="20" height="12" x="2" y="6" rx="2" /><circle cx="12" cy="12" r="2" /><path d="M6 12h.01M18 12h.01" /></svg>',
    'cat_bonus': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>',
    'cat_investment': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v18h18" /><path d="m19 9-5 5-4-4-3 3" /></svg>',
    'cat_revenue': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17"/><path d="m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9"/><path d="m2 16 6 6"/><circle cx="16" cy="9" r="2.9"/><circle cx="6" cy="5" r="3"/></svg>',
    'cat_parttime': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 6v6l4 2"/><circle cx="12" cy="12" r="10"/></svg>',
};

// 莫蘭迪/Aurora 圓環與進度條柔和色彩 Hex/Tailwind 對映
const donutColors = [
    { bgClass: 'bg-indigo-500', hex: '#6366f1' },
    { bgClass: 'bg-purple-500', hex: '#a855f7' },
    { bgClass: 'bg-amber-500', hex: '#f59e0b' },
    { bgClass: 'bg-emerald-500', hex: '#10b981' },
    { bgClass: 'bg-rose-500', hex: '#f43f5e' },
    { bgClass: 'bg-sky-500', hex: '#0ea5e9' },
    { bgClass: 'bg-pink-500', hex: '#ec4899' },
    { bgClass: 'bg-teal-500', hex: '#14b8a6' }
];

// 當前類別卡片切換狀態 ('expense' | 'income')
let activeCategoryTab = 'expense';

/**
 * 格式化佔比百分比（大於等於 1% 顯示整數，小於 1% 保留 1 位小數，如 0.5%）
 */
function formatPercentage(amount, total) {
    if (total <= 0 || amount <= 0) return '0%';
    const raw = (amount / total) * 100;
    if (raw < 1) {
        return `${raw.toFixed(1)}%`;
    }
    return `${Math.round(raw)}%`;
}

/**
 * 繪製 SVG Donut Chart 圓環圖
 */
function renderDonutChart(sortedCategories, totalAmount, isIncomeMode = false) {
    if (!dom.reportDonutSvg) return;
    dom.reportDonutSvg.innerHTML = '';

    const radius = 35;
    const circumference = 2 * Math.PI * radius; // 約 219.91

    const centerTitle = isIncomeMode ? t('totalIncome') : t('totalExpense');

    if (sortedCategories.length === 0 || totalAmount <= 0) {
        // 空狀態：畫一個灰色的底環
        const emptyCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        emptyCircle.setAttribute('cx', '50');
        emptyCircle.setAttribute('cy', '50');
        emptyCircle.setAttribute('r', radius);
        emptyCircle.setAttribute('fill', 'none');
        emptyCircle.setAttribute('stroke', 'rgba(148, 163, 184, 0.2)');
        emptyCircle.setAttribute('stroke-width', '12');
        dom.reportDonutSvg.appendChild(emptyCircle);

        if (dom.reportDonutValue) dom.reportDonutValue.textContent = '$0';
        if (dom.reportDonutLabel) dom.reportDonutLabel.textContent = t('emptyState');
        return;
    }

    if (dom.reportDonutValue) dom.reportDonutValue.textContent = formatCurrency(totalAmount);
    if (dom.reportDonutLabel) dom.reportDonutLabel.textContent = centerTitle;

    // 繪製背景亮色底環
    const bgCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    bgCircle.setAttribute('cx', '50');
    bgCircle.setAttribute('cy', '50');
    bgCircle.setAttribute('r', radius);
    bgCircle.setAttribute('fill', 'none');
    bgCircle.setAttribute('stroke', 'rgba(148, 163, 184, 0.15)');
    bgCircle.setAttribute('stroke-width', '12');
    dom.reportDonutSvg.appendChild(bgCircle);

    let accumPercent = 0;

    sortedCategories.forEach(([catKey, amount], index) => {
        const percent = amount / totalAmount;
        const strokeDashLength = percent * circumference;
        const color = donutColors[index % donutColors.length].hex;

        const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        circle.setAttribute('cx', '50');
        circle.setAttribute('cy', '50');
        circle.setAttribute('r', radius);
        circle.setAttribute('fill', 'none');
        circle.setAttribute('stroke', color);
        circle.setAttribute('stroke-width', '12');
        circle.setAttribute('stroke-dasharray', `${strokeDashLength} ${circumference - strokeDashLength}`);
        circle.setAttribute('stroke-dashoffset', `-${accumPercent * circumference}`);
        circle.classList.add('transition-all', 'duration-300', 'hover:opacity-80', 'cursor-pointer');

        const percentStr = formatPercentage(amount, totalAmount);

        // 懸浮/觸碰圓弧時，動態更新中間顯示
        circle.addEventListener('mouseenter', () => {
            if (dom.reportDonutLabel) dom.reportDonutLabel.textContent = t(catKey);
            if (dom.reportDonutValue) dom.reportDonutValue.textContent = `${percentStr} (${formatCurrency(amount)})`;
        });
        circle.addEventListener('mouseleave', () => {
            if (dom.reportDonutLabel) dom.reportDonutLabel.textContent = centerTitle;
            if (dom.reportDonutValue) dom.reportDonutValue.textContent = formatCurrency(totalAmount);
        });

        dom.reportDonutSvg.appendChild(circle);
        accumPercent += percent;
    });
}

/**
 * 渲染報表頁面數據
 */
export async function renderReportsView() {
    const date = state.currentDate || new Date();
    
    // 1. 更新月份標題
    if (dom.reportMonthDisplay) {
        dom.reportMonthDisplay.textContent = formatMonthDisplay(date);
    }

    // 更新 Header 按鈕狀態 (判斷未來月份不可點)
    const today = new Date();
    const currentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const appDate = new Date(date.getFullYear(), date.getMonth(), 1);

    if (dom.reportNextMonth) {
        if (appDate >= currentMonth) {
            dom.reportNextMonth.disabled = true;
            dom.reportNextMonth.classList.add('opacity-30', 'cursor-not-allowed');
        } else {
            dom.reportNextMonth.disabled = false;
            dom.reportNextMonth.classList.remove('opacity-30', 'cursor-not-allowed');
        }
    }

    // 更新 Tab 切換按鈕 UI 樣式 (100% 精準對齊全站顏色規範：支出 Rose-500/400，收入 Emerald-500/400)
    if (dom.reportTabExpense && dom.reportTabIncome) {
        const activeExpenseClass = 'px-3 py-1 rounded-md bg-rose-500 dark:bg-rose-400 text-white dark:text-slate-950 font-bold shadow-md transition-all scale-[1.02]';
        const activeIncomeClass = 'px-3 py-1 rounded-md bg-emerald-500 dark:bg-emerald-400 text-white dark:text-slate-950 font-bold shadow-md transition-all scale-[1.02]';
        const inactiveClass = 'px-3 py-1 rounded-md text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100 font-medium transition-all opacity-70 hover:opacity-100';

        if (activeCategoryTab === 'expense') {
            dom.reportTabExpense.className = activeExpenseClass;
            dom.reportTabIncome.className = inactiveClass;
        } else {
            dom.reportTabIncome.className = activeIncomeClass;
            dom.reportTabExpense.className = inactiveClass;
        }
    }

    // 2. 拉取當月數據
    let transactions = [];
    try {
        transactions = await storageService.getTransactions(state.userId, date);
    } catch (e) {
        console.error("[Reports] Failed to load transactions for report:", e);
    }

    // 3. 計算總收入、總支出、日均支出
    let totalIncome = 0;
    let totalExpense = 0;
    const expenseCategoryTotals = {};
    const incomeCategoryTotals = {};

    const year = date.getFullYear();
    const month = date.getMonth();
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    transactions.forEach(tx => {
        const amount = Number(tx.amount) || 0;
        const cat = tx.category || 'cat_general';
        if (tx.type === 'income') {
            totalIncome += amount;
            incomeCategoryTotals[cat] = (incomeCategoryTotals[cat] || 0) + amount;
        } else {
            totalExpense += amount;
            expenseCategoryTotals[cat] = (expenseCategoryTotals[cat] || 0) + amount;
        }
    });

    const isIncomeMode = activeCategoryTab === 'income';
    const targetCategoryTotals = isIncomeMode ? incomeCategoryTotals : expenseCategoryTotals;
    const targetTotalAmount = isIncomeMode ? totalIncome : totalExpense;

    // 根據當前 Tab 模式計算日均 (日均支出 vs 日均收入)
    const currentTotalForDaily = isIncomeMode ? totalIncome : totalExpense;
    const rawDailyAvg = currentTotalForDaily > 0 ? (currentTotalForDaily / daysInMonth) : 0;
    // 大於等於 1 顯示整數，小於 1 則保留小數 (如 0.2, 0.55)
    const dailyAvg = rawDailyAvg >= 1 ? Math.round(rawDailyAvg) : parseFloat(rawDailyAvg.toFixed(2));

    // 填入概覽卡片
    if (dom.reportTotalIncome) dom.reportTotalIncome.textContent = formatCurrency(totalIncome);
    if (dom.reportTotalExpense) dom.reportTotalExpense.textContent = formatCurrency(totalExpense);
    if (dom.reportDailyAvgLabel) dom.reportDailyAvgLabel.textContent = isIncomeMode ? t('dailyIncomeAverage') : t('dailyExpenseAverage');
    if (dom.reportDailyAvg) dom.reportDailyAvg.textContent = formatCurrency(dailyAvg);

    // 4. 根據當前選中的 Tab 渲染標題、Donut Chart 圓環圖與排行榜
    // 動態更新卡片標題
    if (dom.reportCategoryTitle) {
        dom.reportCategoryTitle.textContent = isIncomeMode ? t('incomeCategoryBreakdown') : t('expenseCategoryBreakdown');
    }
    if (dom.reportTrendTitle) {
        dom.reportTrendTitle.textContent = isIncomeMode ? t('recent7DaysIncomeTrend') : t('recent7DaysExpenseTrend');
    }

    const sortedCategories = Object.entries(targetCategoryTotals).sort((a, b) => b[1] - a[1]);
    renderDonutChart(sortedCategories, targetTotalAmount, isIncomeMode);

    // 5. 類別佔比排行榜 (Progress List)
    if (dom.reportCategoryList) {
        dom.reportCategoryList.innerHTML = '';

        if (sortedCategories.length === 0) {
            dom.reportCategoryList.innerHTML = `
                <p class="text-xs text-slate-400 dark:text-slate-500 text-center py-4">${escapeHTML(t('emptyState'))}</p>
            `;
        } else {
            sortedCategories.forEach(([catKey, amount], index) => {
                const percentStr = formatPercentage(amount, targetTotalAmount);
                const rawPercent = targetTotalAmount > 0 ? (amount / targetTotalAmount) * 100 : 0;
                const iconSvg = categoryIcons[catKey] || categoryIcons['cat_general'];
                const colorConfig = donutColors[index % donutColors.length];
                const catName = t(catKey);

                const itemEl = document.createElement('div');
                itemEl.className = 'space-y-1.5 p-2 rounded-xl hover:bg-slate-200/30 dark:hover:bg-slate-700/30 transition-colors cursor-pointer';
                itemEl.innerHTML = `
                    <div class="flex items-center justify-between text-xs">
                        <div class="flex items-center space-x-2">
                            <!-- 色塊指示圓點，與 Donut 圖形完全對應 -->
                            <div class="w-3 h-3 rounded-full flex-shrink-0" style="background-color: ${colorConfig.hex}"></div>
                            <div class="w-5 h-5 flex items-center justify-center text-slate-600 dark:text-slate-300">
                                ${iconSvg}
                            </div>
                            <span class="font-medium text-slate-800 dark:text-slate-200">${escapeHTML(catName)}</span>
                        </div>
                        <div class="flex items-center space-x-2">
                            <span class="text-[11px] font-semibold text-slate-400 dark:text-slate-500">${percentStr}</span>
                            <span class="font-bold text-slate-900 dark:text-slate-100">${formatCurrency(amount)}</span>
                        </div>
                    </div>
                    <div class="w-full h-1.5 bg-slate-100 dark:bg-slate-700/50 rounded-full overflow-hidden">
                        <div class="h-full ${colorConfig.bgClass} rounded-full transition-all duration-500 ease-out" style="width: ${Math.max(1, rawPercent)}%"></div>
                    </div>
                `;

                // 懸浮清單項目時，中央 Donut 圖同步顯示焦點
                itemEl.addEventListener('mouseenter', () => {
                    if (dom.reportDonutLabel) dom.reportDonutLabel.textContent = catName;
                    if (dom.reportDonutValue) dom.reportDonutValue.textContent = `${percentStr} (${formatCurrency(amount)})`;
                });
                itemEl.addEventListener('mouseleave', () => {
                    if (dom.reportDonutLabel) dom.reportDonutLabel.textContent = isIncomeMode ? t('totalIncome') : t('totalExpense');
                    if (dom.reportDonutValue) dom.reportDonutValue.textContent = formatCurrency(targetTotalAmount);
                });

                dom.reportCategoryList.appendChild(itemEl);
            });
        }
    }

    // 6. 近 7 天趨勢柱狀圖 (連動支出 / 收入 模式)
    if (dom.reportDailyChart) {
        dom.reportDailyChart.innerHTML = '';

        const past7Days = [];
        for (let i = 6; i >= 0; i--) {
            const d = new Date(today);
            d.setDate(today.getDate() - i);
            const yStr = d.getFullYear();
            const mStr = String(d.getMonth() + 1).padStart(2, '0');
            const dStr = String(d.getDate()).padStart(2, '0');
            past7Days.push({
                dateStr: `${yStr}-${mStr}-${dStr}`,
                dayLabel: `${d.getDate()}日`
            });
        }

        let max7DaysAmount = 0;
        const daily7Totals = {};

        past7Days.forEach(({ dateStr }) => {
            const dayTxs = transactions.filter(tx => tx.date === dateStr && tx.type === activeCategoryTab);
            const sum = dayTxs.reduce((acc, curr) => acc + (Number(curr.amount) || 0), 0);
            daily7Totals[dateStr] = sum;
            if (sum > max7DaysAmount) max7DaysAmount = sum;
        });

        const formatCompactAmount = (amt) => {
            if (amt <= 0) return '-';
            if (amt >= 10000) return `$${(amt / 1000).toFixed(1)}k`;
            if (amt >= 1000) return `$${(amt / 1000).toFixed(1)}k`;
            return `$${amt}`;
        };

        const barColorClass = isIncomeMode ? 'bg-emerald-500 dark:bg-emerald-400 group-hover:bg-emerald-600' : 'bg-rose-500 dark:bg-rose-400 group-hover:bg-rose-600';
        const hoverTextColorClass = isIncomeMode ? 'group-hover:text-emerald-500' : 'group-hover:text-rose-500';

        past7Days.forEach(({ dateStr, dayLabel }) => {
            const dayAmount = daily7Totals[dateStr] || 0;
            const isHasVal = dayAmount > 0;

            let heightPercent = 8;
            if (isHasVal && max7DaysAmount > 0) {
                heightPercent = Math.max(12, Math.round((dayAmount / max7DaysAmount) * 95));
            }

            const amountText = formatCompactAmount(dayAmount);

            const barWrapper = document.createElement('div');
            barWrapper.className = 'flex-1 flex flex-col items-center h-full justify-end group relative cursor-pointer';

            barWrapper.innerHTML = `
                <span class="text-[9px] font-bold ${isHasVal ? 'text-slate-700 dark:text-slate-300' : 'text-slate-400/40 dark:text-slate-600'} mb-1 transition-colors ${hoverTextColorClass}">${amountText}</span>
                <div class="w-full flex-1 flex items-end justify-center">
                    <div class="w-full max-w-[14px] rounded-t-md transition-all duration-300 ${isHasVal ? barColorClass + ' shadow-sm' : 'bg-slate-200/50 dark:bg-slate-700/30'}" style="height: ${heightPercent}%;"></div>
                </div>
                <span class="text-[9px] font-medium text-slate-400 dark:text-slate-500 mt-1.5">${dayLabel}</span>
            `;
            dom.reportDailyChart.appendChild(barWrapper);
        });
    }
}

/**
 * 初始化報表模組與事件綁定
 */
export function initializeReports() {
    if (dom.openReportsBtn) {
        dom.openReportsBtn.addEventListener('click', async () => {
            if (dom.reportsView) {
                if (dom.views) {
                    dom.views.forEach(v => {
                        if (v && v !== dom.reportsView) v.style.display = 'none';
                    });
                }
                dom.reportsView.style.display = 'flex';
                await renderReportsView();
            }
        });
    }

    if (dom.backFromReportsBtn) {
        dom.backFromReportsBtn.addEventListener('click', () => {
            if (dom.reportsView) {
                dom.reportsView.style.display = 'none';
                if (dom.userSettingsView) dom.userSettingsView.style.display = 'flex';
            }
        });
    }

    // 支出 / 收入 Tab 切換事件綁定
    if (dom.reportTabExpense) {
        dom.reportTabExpense.addEventListener('click', () => {
            if (activeCategoryTab === 'expense') return;
            activeCategoryTab = 'expense';
            renderReportsView();
        });
    }

    if (dom.reportTabIncome) {
        dom.reportTabIncome.addEventListener('click', () => {
            if (activeCategoryTab === 'income') return;
            activeCategoryTab = 'income';
            renderReportsView();
        });
    }

    // 監聽全局交易更新事件：若當前正開啟報表頁面，則即時刷新數據
    window.addEventListener('app:transactionUpdated', () => {
        if (dom.reportsView && dom.reportsView.style.display !== 'none') {
            renderReportsView();
        }
    });

    // 報表頁面月份切換按鈕事件
    if (dom.reportPrevMonth) {
        dom.reportPrevMonth.addEventListener('click', async () => {
            const date = state.currentDate || new Date();
            date.setMonth(date.getMonth() - 1);
            state.setCurrentDate(date);
            await renderReportsView();
        });
    }

    if (dom.reportNextMonth) {
        dom.reportNextMonth.addEventListener('click', async () => {
            if (dom.reportNextMonth.disabled) return;
            const date = state.currentDate || new Date();
            date.setMonth(date.getMonth() + 1);
            state.setCurrentDate(date);
            await renderReportsView();
        });
    }
}
